import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const Passwords = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { Passwords, defaultState };
